import {
  CHANGE_QUANTITY_API_REQUEST,
  CHANGE_QUANTITY_API_SUCCESS,
  CHANGE_QUANTITY_API_ERROR,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function changeQuantityApiRequest() {
  return {
    type: CHANGE_QUANTITY_API_REQUEST,
    payload: true,
  };
}

function changeQuantityApiSuccess(cart, params) {
  return {
    type: CHANGE_QUANTITY_API_SUCCESS,
    payload: cart,
    params,
  };
}

function changeQuantityApiError(err) {
  return {
    type: CHANGE_QUANTITY_API_ERROR,
    payload: err,
  };
}

export function changeQuantityAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    const { isAuthenticated } = state.auth;
    const alpha2 = state?.locations?.yourLocation?.alpha2;
    params.alpha2 = alpha2;
    // if (!isAuthenticated) {
    //   return dispatch(deleteCartItemSuccess(params));
    // }
    dispatch(changeQuantityApiRequest());
    return cartApi
      .changeQuantity(state, params)
      .then(data => {
        dispatch(changeQuantityApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(changeQuantityApiError(error));
        throw error;
      });
  };
}

export default { changeQuantityAction };
